<template>
   <div class="flex userInfoBox" v-if="userId" @click.stop="$openRef('/user/userDetail/' + userId)">
    <div class="userimg" v-if="userImgPath!='-1'">
      <img class="userimg" :src="userImgPath || '/imgs/gift_user_icon.png'"/>
    </div>
    <div :class="userImgPath!=-1 ? 'flex_column flex_hcenter gutter_l' : 'flex_column flex_hcenter'" style="max-width: 70%;">
      <div>{{userName}}<slot name="isnew"></slot></div>
      <div v-if="userPhone" class="userPhone">
        {{userPhone}}
      </div>
    </div>
  </div>
   <div class="flex" v-else>
    <div class="userimg" v-if="userImgPath!='-1'">
      <img class="userimg" :src="userImgPath || '/imgs/gift_user_icon.png'"/>
    </div>
    <div class="flex_column flex_hcenter gutter_l">
      <div>{{userName}}<slot name="isnew"></slot></div>
      <div v-if="userPhone" class="normalText">
        <span>{{userPhone}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "userInfo",
  props: {
    userId: String,
    userName: String,
    userPhone: String,
    userImgPath: String
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.userInfoBox{
  cursor: pointer;
}
.userimg{
  height: 50px; width: 50px; border-radius: 4px
}
.userPhone{
  // width: 86px;
  text-align: left;
  margin-top: 5px;
  color: #5390c9;
}
.normalText{
  // width: 86px;
  text-align: left;
  margin-top: 5px;
  color: #00000080;
}

</style>
